<template>
  <main class="marketing-email-create-verify">
    <app-form @submit="advanceStep">
      <marketing-email-form-verify v-if="item"
                                   :item="item"
                                   @saved="setItem" />

      <div class="marketing-email-create-verify-actions">
        <button class="btn btn-primary btn-extra-round"
                type="submit">
          {{ submitText }}
        </button>
      </div>
    </app-form>
  </main>
</template>

<script>
import AppForm from "@components/form/Form.vue";
import MarketingEmailFormVerify from "@components/modules/marketing/email/form/verify/MarketingEmailFormVerify";

export default {
  components: {
    MarketingEmailFormVerify,
    AppForm,
  },

  data() {
    return {};
  },

  created() {},

  computed: {
    item() {
      return this.$store.state.marketing.email.create.item ? 
      this.$store.state.marketing.email.create.item :
      this.itemInSessionStorage
    },
    itemInSessionStorage() {
      return JSON.parse(sessionStorage.getItem("email_item"));     
    },
    isAutomationFlow() {
      return this.$store.state.marketing.email.create.data.isAutomationFlow;
    },
    submitText() {
      return this.isAutomationFlow ? this.$t('message.email.message.finish') : this.$t('message.generics.message.advance');
    },
  },

  mixins: [],

  methods: {
    setItem(item) {
      this.$store.commit("EMAIL_CREATE_SET_ITEM", item);
    },
    async advanceStep() {
      this.saveDraft();

      if (this.isAutomationFlow) {
        this.$router.push({
          path: "/marketing/email/",
        });
      } else {
        this.$store.commit("SET_EMAIL_CREATE_STEP", 5);
        sessionStorage.setItem("email_step", 5);

        this.$router.push({
          path: "/marketing/email/criar/envio",
        });
      }
    },
    async saveDraft() {
      await this.$api.marketing.email.message.edit({
        emailId: this.item.id,
        data: {
          ...this.item,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-create-verify {
  .marketing-email-create-verify-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 50px 0;
  }
}
</style>
